import { ISentence } from "us.collection.case/interfaces";

/**
 * To get the sentence details arranged befoe storing in the sentence details redux state
 * @param sentence any sentence value returned form the API
 * @returns valid sentence
 */
export const arrangeSentenceDetails = (sentence: any): ISentence => {
  return sentence && sentence.hasOwnProperty("caseId")
    ? {
        ...sentence,
      }
    : {} as ISentence;
};
